import React from 'react';
import Project from '../Project';
import { projects } from '../../projectsData';


const Projects = () => {

    return (
        <section className='px-3 pt-10 md:p-5 mb-12'>
            <h1 className='text-3xl font-bold my-3 text-gray-800'>My Projects</h1>
            <p className='text-sm mb-3 text-justify'>By showing complete project I want to demonstrate my skills. All the projects below, have been developed from the ground by me. Those projects are live on netlify server and gihub repository url has also been provided. This will help you to know more about skill sets. One thing I want to mention that for the time being my primary focus is on front end development but I do have understanding in backend development using nodejs and express.</p>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-3'>
                {
                    projects.map(project => <Project key={project.id} data={project} />)
                }
            </div>
        </section>
    )
}

export default Projects;
